(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxPrintQueueGroups(
    PrintQueuePropertiesService, $routeParams, URL_PARAMS, $timeout, EventServiceEvents,
    PRINT_QUEUE_GROUP_FILTERS, GroupFilterModel
    ) {
    return {
      restrict: 'EA',
      scope: {
        tenant: '=tenant',
        me: '=me',
        isThisResourceMine: '=isThisResourceMine'
        // This uses printQueuePropertiesModel not the printQueueModel
        // I want to deprecate printQueueModel, but no one but me is complaining about it, so theres that...
      },
      templateUrl: 'app/components/printQueueProperties/printQueueGroups/printQueueGroups.template.html',
      link: function(scope) {

        scope.groupsList = null;
        scope.printQueue = null;
        scope.checkAllCheckboxes = false;
        scope.loadingPage = true;
        scope.dialog = {
          state: 'CLOSED',
          mode: 'NONE'
        };
        scope.search = {string: ''};
        scope.settingsConflict = false;
        const DOMAIN_FILTER = new GroupFilterModel('PRINT_QUEUE_GROUPS_STATIC').filters;
        scope.filtersList = DOMAIN_FILTER.concat(PRINT_QUEUE_GROUP_FILTERS);
        scope.mockedPagingObject = {
          pagingCriteria: {}
        };
        scope.filterModel = {
          info: {name: '' },
        };
        scope.selectedGroups = [];
        scope.modifyGroups = [];
        scope.updateProgression = [];
        scope.UI_LOCK = false;


        (function() {
          setListeners();
          scrollListener();
          getPrintQueue();
        })();

        function getPrintQueue() {
          const printerId = $routeParams[URL_PARAMS.PRINTER_URL.ROUTE]
          const queueId = $routeParams[URL_PARAMS.PRINT_QUEUE_URL.ROUTE]
          const url = `${scope.tenant.info._links['px:printers'].href}/${printerId}/queues/${queueId}`;
          scope.loadingPage = true;
          PrintQueuePropertiesService.getPrintQueue(url)
            .then(function (printQueue) {
              checkSettingsConflicts(printQueue)
              scope.printQueue = printQueue;
              scope.isAnywherePrintQueue = !isNaN(parseInt(scope.printQueue.info.signId));
              scope.loadingPage = false;
            })
            .catch(function() {
              scope.loadingPage = false;
            });
        }

        function getQueueGroups() {
          scope.loadingPage = true;
          PrintQueuePropertiesService.getQueueGroups(scope.printQueue)
            .then(function (printQueue) {
              checkSettingsConflicts(printQueue)
              scope.printQueue = printQueue;
              scope.isAnywherePrintQueue = !isNaN(parseInt(scope.printQueue.info.signId));
              scope.loadingPage = false;
            })
            .catch(function() {
              scope.loadingPage = false;
            });
        }

        function checkSettingsConflicts (printQueue) {
          const hasExclusiveAccess = printQueue.groupList.filter(group => group.exclusiveAccess).length
          if (!hasExclusiveAccess || (hasExclusiveAccess === printQueue.groupList.length) ) {
            scope.settingsConflict = false;
          } else {
            scope.settingsConflict = true;
          }

        }

        scope.reloadList = function () {
          scope.printQueue.groupList = [];

          scope.loadingPage = true;
          $timeout(() => {
            getQueueGroups();
          },500)
        }

        scope.selectAllItems = function () {
          if (scope.checkAllCheckboxes) {
            angular.forEach(scope.groups, function(value) {
              value.options.isSelected = scope.checkAllCheckboxes;
            });
          }

          if (!scope.checkAllCheckboxes) {
            angular.forEach(scope.printQueue.groupList, function(value) {
              value.options.isSelected = scope.checkAllCheckboxes;
            });
          }

        }

        scope.$watch(function() {
          if (scope.printQueue?.groupList) {
            return scope.printQueue.groupList;
          }
        }, function() {
          if (scope.printQueue?.groupList) {
            scope.modifyGroups = scope.selectedGroups = scope.printQueue.groupList.findAllElements({
              options: {
                isSelected: true
              }
            });
            if (!scope.selectedGroups.length) {
              scope.checkAllCheckboxes = false;
            } else {
              scope.checkAllCheckboxes = (scope.selectedGroups.length === scope.printQueue.groupList.length);
            }
          }
        }, true);

        scope.setFilters = function () {
          for (const key in scope.mockedPagingObject.pagingCriteria) {
            const value = scope.mockedPagingObject.pagingCriteria[key];
            if (value === true || value === false) {
              scope.filterModel[key] = value;
            } else if (value === null && scope.filterModel.hasOwnProperty(key)) {
              delete scope.filterModel[key];
            }
          }

        }

        scope.domainFiltering = function  (group) {
          var filteredGroup = null;
          if (!scope.mockedPagingObject.pagingCriteria.directories) {
            filteredGroup = group
          } else {

            scope.mockedPagingObject.pagingCriteria.directories.forEach((directory) => {
              if (group.domainOrigin._links.self.href === directory) {
                filteredGroup = group
              }
            })
          }
          return filteredGroup;
        }

        scope.openDialog = function (mode) {
          scope.context = { name: "Groups", task: 'EDIT_HOME_OFFICE_GROUPS', printQueue: scope.printQueue};
          scope.dialog.state = 'OPEN';
          scope.dialog.mode = mode;
        }

        scope.closeDialog = function (exitState) {

          if (exitState === 'UPDATING') {
            scope.UI_LOCK = true;
            angular.forEach(scope.groups, (group) => {
              group.options.isSelected = false;
            })
          }
          scope.context = null;
          scope.dialog.state = 'CLOSED';
          scope.dialog.mode = 'NONE';
        }

        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // TOOLTIP STUFF
        ////////////////////////////////////////////
        scope.showTooltip = function (showTip, position, tooltipScope, context, arg) {
          if (showTip) {
            switch(tooltipScope) {
              case 'settingsConflict':
                settingConflictTooltip(position, context)
                break;
            }
          } else {
            scope.clearTooltip();
          }
        }

        function settingConflictTooltip (position, title, arg) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: title,
            arg: arg,
            type: 'statement',
          }
          scope.tooltipObject = {
            position: {left: position.startX, top: position.startY + 20}
          }
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        }

        scope.quickOpenSiteMenu = function (event, context, menuOption) {
          scope.dialog.state = 'OPEN';
          scope.dialog.mode = 'NONE';
          scope.menuContent = null;
          scope.menuSpecs = null;
          scope.selectedContextMenuItem  =  null;
          scope.contextContentPosition = null;
          scope.contextContent = null;
          $timeout(function  () {
            scope.selectedContextMenuItem  =  menuOption;
            scope.contextContentPosition = { left: event.clientX, top: event.clientY }
            scope.contextContent = context;
          }, 50);

        }

        scope.closeAllMenues = function (context) {
          if (context.autoInstall !== scope.printQueue.info.autoInstall) {
            getPrintQueue();
          }
          scope.selectedContextMenuItem  =  null;
          scope.contextContentPosition = null;
          scope.contextContent = null;
          scope.dialog.state = 'CLOSED'
          scope.dialog.mode = 'NONE';
        }

        scope.openListMenu = function (event, group) {
          var position = document.getElementById(event.target.id).getBoundingClientRect();
          setTimeout(function () {
            scope.closeListMenu();
            group.customProperties = {id: group.id};
            scope.listMenuContext = group;
            scope.listMeta = {
              position: {left: position.x, top: position.y},
              parentId: event.target.id,
              type: 'printQeueGroup',
              scrollContainerId: 'PRINT_QUEUE_GROUP_SCROLL_CONTAINER'
            }
            scope.$apply();
          }, 50)
        }

        scope.closeListMenu = function (group, action) {
          scope.listMenuContext = null;
          scope.listMeta = null;

          switch (action) {
            case 'REMOVE':
              scope.modifyGroups = [group]
              scope.openDialog('REMOVE_GROUPS');
            break;
            case 'MODIFY':
              scope.modifyGroups = [group]
              scope.openDialog('MODIFY_GROUPS');
            break;
          }
        }

        scope.isGroupPassingSearchPattern = function (group, searchPatternGroups) {
          if (!searchPatternGroups) {
            return true;
          }
          if (group) {
            var foundByName = false;
            var foundByDescription = false;
            if (group.name) {
              foundByName = group.name.toLowerCase().indexOf(searchPatternGroups.toLowerCase()) !== -1;
            }
            if (group.description) {
              foundByDescription = group.description.toLowerCase().indexOf(searchPatternGroups.toLowerCase()) !== -1;
            }
            if (foundByName || foundByDescription) {
              return true;
            }
          }
          return false;
        };


        function scrollListener () {
          var scrollLeft = 0;
          var scrollTop = 0;

          angular.element('#PRINT_QUEUE_GROUP_SCROLL_CONTAINER').on('scroll', function (event) {
            if (event.currentTarget.scrollLeft !== scrollLeft) {
              scope.scrollingLEFT = true;
              scrollLeft = event.currentTarget.scrollLeft;
              scope.$apply();
            } else {
              scope.scrollingLEFT = false
            }
            if (scope.scrollingLEFT) {
              $timeout(() => {
                scope.scrollingLEFT = false;
              }, 1500)
            }
          });
        }

        function setListeners () {
          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINT_QUEUE_GROUPS_UPDATED, function (name, data) {
            if (data.printQueue === scope.printQueue.info._links.self.href) {
              if (scope.dialog.state === 'CLOSED' && !scope.UI_LOCK) {
                getQueueGroups();
              }
            }
          });

          scope.$on('PRINT_QUEUE_GROUPS_UPDATE_CALLBACK', function (name, data) {
            scope.search.string = '';
            getQueueGroups();
            scope.UI_LOCK = false;
            scope.updateProgression = [];
          });

          scope.$on('PRINT_QUEUE_GROUPS_UPDATE', function (name, data) {
            scope.updateProgression.push(data)
          });
        }
      }
    };
  }

  pxPrintQueueGroups.$inject = [
    'PrintQueuePropertiesService', '$routeParams', 'URL_PARAMS', '$timeout', 'EventServiceEvents',
    'PRINT_QUEUE_GROUP_FILTERS', 'GroupFilterModel'];

  angular
    .module('printix-admin')
    .directive('pxPrintQueueGroups', pxPrintQueueGroups)
    .constant("PRINT_QUEUE_GROUP_FILTERS", [
      {
        name: 'ExclusiveAccess',
        parameter: 'exclusiveAccess',
        type: 'radio',
        values: [
          {
            key: 'exclusiveAccess',
            value: 'Yes',
            state: true
          },
          {
            key: 'exclusiveAccess',
            value: 'No',
            state: false
          },
          {
            key: 'exclusiveAccess',
            value: 'ClearFilter',
            state: null
          }
        ]
      },
      {
        name: 'AddQueueAutomatically',
        parameter: 'autoInstall',
        type: 'radio',
        values: [
          {
            key: 'autoInstall',
            value: 'Yes',
            state: true
          },
          {
            key: 'autoInstall',
            value: 'No',
            state: false
          },
          {
            key: 'autoInstall',
            value: 'ClearFilter',
            state: null
          }
        ]
      },
      {
        name: 'SetAsDefaultPrinter',
        parameter: 'defaultForGroup',
        type: 'radio',
        values: [
          {
            key: 'SetAsDefaultPrinter',
            value: 'Yes',
            state: true
          },
          {
            key: 'SetAsDefaultPrinter',
            value: 'No',
            state: false
          },
          {
            key: 'SetAsDefaultPrinter',
            value: 'ClearFilter',
            state: null
          }
        ]
      }
    ]);


})();
